import { differenceInDays, differenceInWeeks } from 'date-fns';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import { useDateUtils } from '@utils/Date.utils';
import { useTranslations } from '@hooks/useTranslations';

const getRelativeAvailabilityTime = (availabilityDate: string) => {
    const { t } = useTranslations();
    const { formatDate } = useDateUtils();
    const available = new Date(availabilityDate);
    const now = new Date();

    const daysDiff = differenceInDays(now, available);
    const weeksDiff = differenceInWeeks(now, available);

    if (weeksDiff > 1 && weeksDiff < 6) {
        return (
            <Trans t={t} i18nKey="stockModelCard.availabilityInWeeks" count={weeksDiff}>
                <span>
                    Disponible dans <b>{{ weeksDiff }} semaines</b>
                </span>
            </Trans>
        );
    } else if (daysDiff > 0 && daysDiff < 15) {
        return (
            <Trans t={t} i18nKey="stockModelCard.availabilityInDays" count={daysDiff}>
                <span>
                    Disponible en <b>{{ daysDiff }} jours</b>
                </span>
            </Trans>
        );
    } else {
        const availabilityDate = formatDate(available, undefined, 'L');

        return i18n.t('stockModelCard.availableTo', { availabilityDate });
    }
};

export default getRelativeAvailabilityTime;
